import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FETCH_USERS, FETCH_USER, USER_CREATE, USER_SAVE, USER_REMOVE, USER_AND_ROLE_ADD, USER_AND_ROLE_REMOVE, FETCH_ERROR } from './actions.type'
import { SET_USERS, SET_USERS_ERRORS, SET_USERS_LOADING, SET_USER, SET_USER_ERRORS, SET_USER_LOADING, SET_USER_AND_ROLE_ERRORS, SET_USER_AND_ROLE_LOADING } from './mutations.type'

const state = {
	users: [],
	usersErrors: [],
	usersIsLoading: false,
	user: null,
	userErrors: [],
	userIsLoading: false,
	userAndRoleErrors: [],
	userAndRoleIsLoading: false
}

const getters = {
	users : state => (key, filters = []) => {
		// Если фильтры не переданы или пусты, используем все доступные фильтры по умолчанию
		if (!filters || filters.length === 0) {
			filters = ['uid', 'fullName', 'lastName', 'firstName', 'middleName', 'email', 'organization', 'position']
		}
		
		const searchKey = (key || '').toLowerCase()
		
		return state.users.filter(x => {
			// Если поисковый запрос пуст, возвращаем все записи
			if (!searchKey) {
				return true
			}
			
			// Проверяем каждый выбранный фильтр
			for (let filterId of filters) {
				let fieldValue = null
				
				switch(filterId) {
					case 'uid':
						fieldValue = x.uid
						break
					case 'fullName':
						fieldValue = x.fullName
						break
					case 'lastName':
						fieldValue = x.lastName
						break
					case 'firstName':
						fieldValue = x.firstName
						break
					case 'middleName':
						fieldValue = x.middleName
						break
					case 'email':
						fieldValue = x.email
						break
					case 'organization':
						fieldValue = x.organization
						break
					case 'position':
						fieldValue = x.position
						break
				}
				
				if (fieldValue && fieldValue.toString().toLowerCase().includes(searchKey)) {
					return true
				}
			}
			
			return false
		})
		.sort((one, two) => {
			var x = one.fullName.toLowerCase()
			var y = two.fullName.toLowerCase()
			if (x < y) {
				return -1
			}
			if (x > y) {
				return 1
			}
			return 0
		})
	},
	usersErrors (state) {
		return state.usersErrors
	},
	usersIsLoading (state) {
		return state.usersIsLoading
	},
	user (state) {
		return state.user
	},
	userErrors (state) {
		return state.userErrors
	},
	userIsLoading (state) {
		return state.userIsLoading
	},
	userAndRoleErrors (state) {
		return state.userAndRoleErrors
	},
	userAndRoleIsLoading (state) {
		return state.userAndRoleIsLoading
	}
}

const actions = {
	[FETCH_USERS] (context, params) {
		context.commit(SET_USERS_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.query('manager/users')
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_USERS, data)
					resolve(data)
				} else {
					context.commit(SET_USERS_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_USERS_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_USERS_LOADING, false)
			})
		})
	},
	[FETCH_USER] (context, params) {
		context.commit(SET_USER_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.getBy('manager/users', params.uid)
			.then(({data}) => {
				if (typeof data == "object") {
					data.password_confirm = null // это свойство теряет реактивность, если добавлять в другом месте, переставет работать валидация
					context.commit(SET_USER, data)
					resolve(data)
				} else {
					context.commit(SET_USER_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_USER_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_USER_LOADING, false)
			})
		})
	},
	[USER_CREATE] (context, params) {
		context.commit(SET_USER_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post('manager/users', params)
			.then(({data}) => {
				if (data === true) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Пользователь создан", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось создать пользователя" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось создать пользователя" })
				ErrorsService.setFetchError(SET_USER_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_USER_LOADING, false)
			})
		})
	},
	[USER_SAVE] (context, params) {
		context.commit(SET_USER_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(`manager/users/${params.uid}`, params)
			.then(({data}) => {
				if (data === true) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Пользователь сохранен", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось сохранить" })
				ErrorsService.setFetchError(SET_USER_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_USER_LOADING, false)
			})
		})
	},
	[USER_REMOVE] (context, params) {
		context.commit(SET_USER_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/users/${params}`)
			.then(({data}) => {
				if (data) {
					state.users = state.users.filter(x => x.uid != params)
					this.dispatch(FETCH_ERROR, { variant: "success", text: "Пользователь удален", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить" })
				ErrorsService.setFetchError(SET_USER_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_USER_LOADING, false)
			})
		})
	},

	[USER_AND_ROLE_ADD] (context, params, isUser) {
		context.commit(SET_USER_AND_ROLE_LOADING)
		context.commit(SET_USER_AND_ROLE_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.post(`manager/users/${params.uid}/roles`, params)
			.then(({data}) => {
				if (data === true) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: isUser ? "Роль добавлена" : "Пользователь добавлен", title: "Готово" })
				} else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось добавить " + (isUser ? "роль" : "пользователя") })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось добавить " + (isUser ? "роль" : "пользователя") })
				ErrorsService.setFetchError(SET_USER_AND_ROLE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_USER_AND_ROLE_LOADING, false)
			})
		})
	},
	[USER_AND_ROLE_REMOVE] (context, params, isUser) {
		context.commit(SET_USER_AND_ROLE_LOADING)
		context.commit(SET_USER_AND_ROLE_ERRORS)
		return new Promise((resolve, reject) => {
			ApiService.delete(`manager/users/${params.uid}/roles/${params.dn}`)
			.then(({data}) => {
				if (data) {
					this.dispatch(FETCH_ERROR, { variant: "success", text: isUser ? "Роль удалена" : "Пользователь удален", title: "Готово" })
				}
				else {
					this.dispatch(FETCH_ERROR, { text: "Не удалось удалить " + (isUser ? "роль" : "пользователя") })
				}
				resolve(data)
			})
			.catch((error) => {
				this.dispatch(FETCH_ERROR, { text: "Не удалось удалить " + (isUser ? "роль" : "пользователя") })
				ErrorsService.setFetchError(SET_USER_AND_ROLE_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_USER_AND_ROLE_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_USERS] (state, data) {	
		state.users = data
		state.usersErrors = []
	},
	[SET_USERS_ERRORS] (state, errors) {
		state.users = []
		state.usersErrors = errors	
	},
	[SET_USERS_LOADING] (state, status = true) {
		state.usersIsLoading = status
	},
	[SET_USER] (state, data) {
		state.user = data
		state.userErrors = []
	},
	[SET_USER_ERRORS] (state, errors) {
		state.user = null
		state.userErrors = [errors]
	},
	[SET_USER_LOADING] (state, status = true) {
		state.userIsLoading = status
	},
	
	[SET_USER_AND_ROLE_ERRORS] (state, errors) {
		if (errors === undefined) {
			state.userAndRoleErrors = []
		}
		else {
			state.userAndRoleErrors = errors
		}		
	},
	[SET_USER_AND_ROLE_LOADING] (state, status = true) {
		state.userAndRoleIsLoading = status
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/users.module.js